import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ChooseWebsitePageActions,
  LoginPageActions,
} from './login-settings.actions';
import {
  selectSettingsFinished,
  selectSettingsLoading,
  selectSettingsSet,
  selectWebsite,
  selectWebsiteId,
  selectWebsiteSet,
} from './login-settings.selectors';

@Injectable({
  providedIn: 'root',
})
export class LoginSettingsFacade {
  private readonly store: Store = inject(Store);

  public readonly website: Signal<string | undefined> =
    this.store.selectSignal(selectWebsite);
  public readonly websiteSet: Signal<boolean> =
    this.store.selectSignal(selectWebsiteSet);
  public readonly settingsSet: Signal<boolean> =
    this.store.selectSignal(selectSettingsSet);
  public readonly settingsLoading: Signal<boolean> = this.store.selectSignal(
    selectSettingsLoading,
  );
  public readonly settingsFinished: Signal<boolean> = this.store.selectSignal(
    selectSettingsFinished,
  );
  public readonly websiteId: Signal<string | undefined> =
    this.store.selectSignal(selectWebsiteId);

  public websiteChosen(website: string): void {
    this.store.dispatch(ChooseWebsitePageActions.websiteChosen({ website }));
  }

  public websiteLogout(): void {
    this.store.dispatch(ChooseWebsitePageActions.websiteLogout());
  }

  public clearWebsite(): void {
    this.store.dispatch(LoginPageActions.clearWebsite());
  }
}
